/**
 * The one cron validity check, pure (cron-parser only) so client components
 * that reach the draft sanitizer never drag the schedule parser's Anthropic
 * client into the browser bundle. schedule-parser re-exports it.
 */

import { parseExpression } from 'cron-parser';

/**
 * True when `cron` is a standard 5-field expression cron-parser can evaluate.
 * This is the same parser the scheduler uses, so "valid here" == "schedulable".
 */
export function isValidCron(cron: string): boolean {
  const trimmed = cron?.trim();
  if (!trimmed) return false;
  // Reject 6+ field (seconds / @-macro) forms — the scheduler only handles the
  // standard 5-field minute-granularity cron, so accepting more would silently
  // mis-fire.
  if (trimmed.split(/\s+/).length !== 5) return false;
  try {
    parseExpression(trimmed);
    return true;
  } catch {
    return false;
  }
}
